import { render, staticRenderFns } from "./messageRules.vue?vue&type=template&id=5cc3f74c&scoped=true"
import script from "./messageRules.vue?vue&type=script&lang=js"
export * from "./messageRules.vue?vue&type=script&lang=js"
import style0 from "./messageRules.vue?vue&type=style&index=0&id=5cc3f74c&prod&lang=scss&scoped=true"
import style1 from "./messageRules.vue?vue&type=style&index=1&id=5cc3f74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3f74c",
  null
  
)

export default component.exports